import { render, staticRenderFns } from "./rapid_diffs_toggle.vue?vue&type=template&id=ba770810"
import script from "./rapid_diffs_toggle.vue?vue&type=script&lang=js"
export * from "./rapid_diffs_toggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports